import { ReactNode } from 'react';

const Small = (...chunks: ReactNode[]) => {
  return <small>{chunks}</small>;
};

export default Small;
